import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import ModalTemplate from '../../../components/modal';
import {colors} from '../../../util/colors';
import {strings} from '../../../util/strings';
import * as fonts from '../../../util/fonts';
import '../styles.scss';
import CoverageCard from '../../../components/coverage-card';
import Header2 from '../../../components/headers/header2';
import {CoveragesItem, Deduct, Franchise} from '../Coverages';
import FranchiseCard from '../../../components/franchise-card';
import CoverDetailCard from '../../../components/cover-detail-card';
import Row from '../../../components/layout/Row';
import Icon from '../../../components/icon/Icon';
import {Icons} from '../../../util/icons';
import AppButton from '../../../components/app-button/AppButton';
import Masonry from '@mui/lab/Masonry';

interface NewCoverageDetailsProps {
  details: any;
  showModal: any;
  setShowModal: any;
  selectedItem: CoveragesItem;
  labels: typeof strings.pt.myCoverages;
  deducts: Deduct[] | any;
  errorFetchingDetail: boolean;
  setErrorFetchingDetail(value: boolean): void;
}

const NewCoverageDetails = ({
  details,
  showModal,
  setShowModal,
  selectedItem,
  labels,
  deducts,
  errorFetchingDetail,
  setErrorFetchingDetail,
}: NewCoverageDetailsProps) => {
  const deductData = deducts?.filter(
    (deduct: Deduct) => deduct.deductType === selectedItem.deductType
  )[0];
  const displayDeducts =
    selectedItem.deductType === '1' && selectedItem.deductMemAmt;

  let headerFont = window.innerWidth <= 550 ? '19px' : '36px';
  const renderNoCoverageDetailsModal = () => (
    <ModalTemplate
      show={showModal}
      onHide={() => {
        setShowModal(false);
        setErrorFetchingDetail(false);
      }}
      hideFooter={true}
      cross={true}>
      <Row className="insert-new-data-modal-row insert-new-data-modal-title insert-new-data-modal-text">
        <Header2
          style={{
            ...fonts.L,
            ...fonts.Bold,
            color: colors.black,
            fontSize: '24px',
            marginBottom: '20.5px',
          }}
          className="coverages-detail-modal-header">
          {labels?.cover}
        </Header2>
      </Row>

      <Row className="insert-new-data-modal-icon-row">
        <Icon
          changeViewbox
          viewBox={'0 0 24 25'}
          width="32"
          height="32"
          color={colors.alertRed}
          name={Icons.ALERT_PROBLEM}
        />
      </Row>
      <Row
        className="insert-new-data-modal-row"
        style={{
          ...fonts.MM,
          color: colors.alertRed,
          marginBottom: '0px',
          padding: '0px 55px',
        }}>
        {errorFetchingDetail ? labels?.error_fetching : labels?.noDetail_title}
      </Row>
      <Row
        className="insert-new-data-modal-row"
        style={{
          fontSize: '17px',
          textAlign: 'center',
          marginTop: '10px',
          marginBottom: '40px',
          fontFamily: 'Poppins',
        }}>
        {!errorFetchingDetail && labels?.noDetail_message}
      </Row>
      <AppButton
        className="insert-new-data-modal-error-button"
        variant="secondary"
        onClick={() => {
          setShowModal(false);
        }}>
        {labels?.noDetail_button}
      </AppButton>
    </ModalTemplate>
  );

  const renderCoverageDetailsModal = (isFirstLevel: boolean) => (
    <ModalTemplate
      className="coverages-detail-modal"
      show={showModal}
      onHide={() => setShowModal(false)}
      hideFooter={true}
      cross={true}>
      <div className="coverage-details-wrapper">
        <div className="coverage-details-header">
          <Header2
            style={{
              ...fonts.L,
              ...fonts.Bold,
              color: colors.black,
              fontSize: headerFont,
            }}
            className="coverages-detail-modal-header">
            {labels?.cover}
          </Header2>

          <div
            className="coverage-details-header-resume"
            style={{background: colors.backgroundGrey}}>
            <CoverageCard details={true} coveragesItem={selectedItem} />
            <p
              className="coverage-description"
              style={{
                ...(window.innerWidth <= 550
                  ? {fontSize: '12px', fontFamily: 'Poppins', fontWeight: 600}
                  : fonts.M),
              }}>
              {selectedItem.catDesc}
            </p>
            {displayDeducts && (
              <FranchiseCard cover={selectedItem} deductData={deductData} />
            )}
          </div>
        </div>
        <div className="coverage-details-body">
          <p className="coverage-details-body-header">
            {labels?.conditions_limits}
          </p>
          <Masonry
            columns={{xs: 1, md: 2}}
            spacing={0.3}
            className="overflow-hidden">
            {isFirstLevel ? (
              <CoverDetailCard
                isFirstLevel={true}
                detail={selectedItem}
                deducts={deducts}
              />
            ) : (
              details.map((detail: any) => (
                <CoverDetailCard detail={detail} deducts={deducts} />
              ))
            )}
          </Masonry>
        </div>
        <div className="coverage-details-footer">
          <p>{labels?.endPageNote}</p>
        </div>
      </div>
    </ModalTemplate>
  );

  return details.length === 0
    ? !selectedItem.copayValue &&
      (!selectedItem.copayName || selectedItem.copayName === '')
      ? renderNoCoverageDetailsModal()
      : renderCoverageDetailsModal(true)
    : renderCoverageDetailsModal(false);
};

const mapStateToProps = ({selectedBu, globalStyles, strings}: any) => ({
  selectedBu: selectedBu.value,
  buStyles: globalStyles.value,
  labels: strings.value.pt.myCoverages,
});

export default compose(connect(mapStateToProps)(NewCoverageDetails));
